import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./styles.scss";

import Header from "components/Layout/Header";
import Button from "components/Button";

const EkycComplete = (props) => {
    const isMidEnrollment = useSelector((state) => state.contract.isMidEnrollment);
    const successorGubun = useSelector((state) => state.ekyc.successorGubun);
    const resultType = useSelector((state) => state.ekyc.resultType);

    useEffect(() => {
        if (resultType !== 1) {
            props.history.replace("/ekyc/start");
        }
    }, []);

    useEffect(() => {
        window.addEventListener("beforeunload", function (e) {
            e.preventDefault();
            e.returnValue = "변경사항은 저장되지 않습니다";
        });
    }, []);

    const handleNext = () => {
        if (isMidEnrollment) {
            props.history.push("/auth/midInfo");
        } else if (successorGubun === "A") {
            props.history.push("/successor/afterinfo");
        } else if (successorGubun === "B") {
            props.history.push("/successor/contractInfo");
        } else {
            props.history.push("/auth/contractInfo");
        }
    };

    return (
        <>
            <Header onClick={() => props.history.push("/")} />
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <div className={styles.innerWrap}>
                        <div className={styles.completeBox}>
                            <div className={styles.iconWrap}>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                    <circle cx="32" cy="32" r="32" fill="#DA291C" fillOpacity="0.1" />
                                    <path d="M20 33L28 41L44 24" stroke="#DA291C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h1 className={styles.title}>비대면 본인인증 완료</h1>
                            <p className={styles.desc}>
                                비대면 본인인증이 완료되었습니다.
                                <br />
                                계약 정보 확인을 진행해주세요.
                            </p>
                        </div>
                        <Button
                            text={"계약 정보 확인"}
                            style={{ backgroundColor: "#DA291C", marginTop: "48px" }}
                            onClick={handleNext}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default EkycComplete;
